
/* eslint-disable react-hooks/exhaustive-deps */
// components/Counter.tsx
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/reducers';
import "./invoiceFull.scss"
import { useNavigate, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store';
import HomeBanner from '../../components/HomeBanner/HomeBanner';
import ShareInvoiceQrcode from '../../components/shareInvoiceQrcode/shareInvoiceQrcode';
import QRCodeStyling from "qr-code-styling";
import { useRef, useEffect, useState } from 'react';
import QrcodeImage from "../../assets/images/qr_code_2.svg"
import { Button } from '@material-ui/core';
import PinDropIcon from '@mui/icons-material/PinDrop';
const qrCode = new QRCodeStyling({
  width: 200,
  height: 200,
  dotsOptions: {
    color: "#000",
    type: "square"
  },
  imageOptions: {
    crossOrigin: "anonymous",
    margin: 20
  },

});
const InvoiceFull = () => {
  const state = useSelector((state: RootState) => state.appReducer);
  const { userInfo, cart, storeManagerList, extrasFieldsPopup, langValue, paymentMethodPopUp } = state;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slug, bId } = useParams()
  const {
  } = bindActionCreators(actionCreators, dispatch);
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const ref = useRef(null);
  const [url, setUrl] = useState("https://shop.enabill.dev/hassan-ki-dukan?table=2&branch=2");

  useEffect(() => {
    if (ref.current != null) {
      qrCode.append(ref.current);
    }

  }, []);

  useEffect(() => {
    qrCode.update({
      data: url
    });
  }, [url]);
  return (
    <div id='invoiceFull'>
      {/* <HomeBanner/> */}
      <div className='px-2'>
        <div className="qrcodeParent d-flex flex-column align-items-center mt-5">
          <div className="App  ">
            <div className="d-flex justify-content-center" ref={ref} />
            <div className=" d-flex  mt-3 inputWrapper" style={styles.inputWrapper}>
            </div>
          </div>


          <div>
            <h1 className='text-center success familysora700'>You booked successfully!</h1>
            <p className='text-center reserve familysora700'>Reservation number: 828339</p>
            <p className='text-center displaytext familysora400'>You can use this QR code <br />
              in restaurant</p>
          </div>
        </div>
        <hr />

        <div className='d-flex flex-column align-items-center'>
          <p className='text-center reserve familysora700'>Contact Info</p>
          <p className='text-center displaytext familysora400 mb-0'>Guramishvili Ave 23<br />
            in restaurant</p>
          <p className='text-center displaytext familysora600 numberText'>+995 5673 8397649  <br />
          </p>
          <Button

            className="text-capitalize"

          > <PinDropIcon/> <span className='mx-1'>See on Map</span> 

          </Button>
        </div>
        <hr />
        <div>
          <p className='text-center reserve familysora700'>A note from us</p>
          <p className='text-center displaytext familysora400'>Thank you for choosing our restaurant! Your reservation for 05 march 2023 is confirmed.Our team is dedicated to making your dining experience exceptional. Should you have any special requests or dietary preferences, please inform us in advance. We look
            forward to welcoming you for a delightful culinary journey.<br />
            in restaurant</p>
        </div>
        <hr />
        <div>
          <p className='text-center reserve familysora700'>Our team commitment</p>
          <p className='text-center displaytext familysora400'>Our team is dedicated to making your dining experience exceptional!<br />
            in restaurant</p>
        </div>
        <hr />


        <div className="d-flex paySecure w-100 mt-4 pb-4 align-items-center justify-content-center">
              <p
                className={` m-0 ${
                  state.langValue === "ar"
                    ? ""
                    : "familysora600"
                }`}
              >
                pay securely with
              </p>
              <img
                src={`/images/pat-enabill.svg`}
                className="mx-2 img-pro"
                height="21px"
                alt="bill"
              />
            </div>

        {/* <ShareInvoiceQrcode /> */}





        {/* <BtnNext handleCheckout={() => router.push(`/${slug}/step-3`)} label="Next Checkout" /> */}



      </div>
    </div>
  );
};

const styles = {
  inputWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  inputBox: {
    width: "100%",
    margin: "0px"

  }
};
export default InvoiceFull;